import { styled, CircularProgress } from "@mui/material";

export const StyledCircularProgress = styled(CircularProgress)`
  stroke-linecap: round;
`;

export const CircularBackground = styled(CircularProgress)`
  color: ${(props) =>
    props.theme.palette.grey[props.theme.palette.mode === "light" ? 200 : 800]};
  position: absolute;
`;
